import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

import cx from 'classnames';
// Style
import {
  Grid,
  Row,
  Col,
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Transaction.css';

// Component
import AccountSettingsSideMenu from '../../components/AccountSettingsSideMenu';
import Transaction from '../../components/Transaction';

// Graphql
import getTransactionHistory from './getTransactionHistory.graphql';
import { withQuery } from '../../hoc/withGraphql';

const TransactionContainer = ({ data, mode }) => {
  return (
    <Grid fluid className={'dashBoardContainer'}>
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className={cx('dashBoardListingGrid', s.transactionGrid)}>
            <AccountSettingsSideMenu />
            <div className={s.secondContainer}>
              <Transaction data={data} mode={mode} />
            </div>
          </div>
        </Col>
      </Row>
    </Grid>
  );
};

TransactionContainer.propTypes = {
  data: PropTypes.object.isRequired,
  mode: PropTypes.string,
};

export default compose(
  withStyles(s),
  withQuery(getTransactionHistory, {
    options: (props) => ({
      variables: {
        mode: props.mode,
        currentPage: 1,
      },
      fetchPolicy: 'network-only',
      ssr: false
    }),
  })
)(TransactionContainer);
